import React from "react";
import useTenant from "src/hooks/api/services/tenants/useTenant";

type LogoVariant = "default" | "small";
type LogoColor = "primary" | "white" | "dark";

interface LogoProps {
	color: LogoColor;
	variant: LogoVariant;
	className?: string;
}

const Logo = (props: LogoProps) => {
	const { tenant } = useTenant();
	const slug = tenant?.slug;

	if (slug === "getcrewdone") {
		return <GetCrewDone {...props} />;
	}

	if (slug === "getjobsdone") {
		return <GetJobsDone {...props} />;
	}

	return <></>;
};

const GetCrewDone = ({ variant, className, color }: LogoProps) => {
	const fill = `fill-${color}`;
	if (variant === "small") {
		return (
			<svg
				id="Laag_2"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 912.09 1112.92"
				{...{ className }}
			>
				<g id="Laag_1-2">
					<g>
						<path
							className={fill}
							d="m62.63,377.21c9.46-108.72,46.76-182.49,122.45-258.91C271.57,30.98,382.04,0,513.26,0c78.55,0,151.25,18.18,218.12,54.53,66.85,36.35,119.5,85.87,157.95,148.55l-173,100.29c-19.23-34.26-46.81-60.8-82.73-79.6-35.94-18.8-76.06-28.2-120.34-28.2-77.72,0-129.6,14.61-181.56,61.01-16.54,14.77-22.64,24.61-32.95,43.94l-236.11,76.7Z"
						/>
						<polygon
							className={fill}
							points="0 700.25 140.72 622.88 33.1 1112.92 394.44 435.32 250.57 504.12 295.47 339.05 62.59 421.67 0 700.25"
						/>
						<path
							className={fill}
							d="m357.95,586.2c46.16,47.85,100.31,64.22,178.03,64.59,44.29.21,84.66-9.2,121.1-28.26,36.45-19.04,63.93-45.24,82.48-78.59l172.52,101.1c-37.9,62.5-90.37,111.77-157.39,147.81-67.04,36.04-140.24,53.87-219.63,53.5-106.27-.5-189.41-23.48-266.08-81.12l-8.31-6.09,97.28-172.93"
						/>
					</g>
				</g>
			</svg>
		);
	}

	if (color === "dark") {
		return (
			<svg
				id="Laag_2"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 2736.44 342.97"
				{...{ className }}
			>
				<g id="Laag_1-2">
					<g>
						<path
							className="fill-dark"
							d="m263.74,118.19v21.89c0,38.18-11.86,68.64-35.57,91.38-23.71,22.74-53.81,34.11-90.28,34.11-39.64,0-72.53-12.77-98.67-38.3C13.07,201.72,0,170.35,0,133.15S12.95,64.45,38.85,38.67C64.75,12.89,96.42,0,133.88,0c23.83,0,45.66,5.35,65.48,16.05,19.82,10.7,35.2,24.81,46.15,42.31l-49.61,28.45c-5.6-8.75-13.92-15.92-24.99-21.52-11.07-5.59-23.53-8.39-37.39-8.39-21.65,0-39.58,7.18-53.81,21.52-14.23,14.35-21.34,32.71-21.34,55.08s7.3,40.19,21.89,54.17c14.59,13.99,34.04,20.98,58.36,20.98,33.8,0,55.57-13.13,65.3-39.4h-68.21v-51.07h128.04Z"
						/>
						<path
							className="fill-dark"
							d="m354.93,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
						/>
						<path
							className="fill-dark"
							d="m661.35,5.11v56.18h-65.66v199.17h-58.36V61.28h-65.66V5.11h189.69Z"
						/>
						<path
							className="fill-dark"
							d="m1887.24,5.11c35.26,0,64.75,12.22,88.46,36.66,23.71,24.44,35.57,54.78,35.57,91.01s-11.85,66.57-35.57,91.01c-23.71,24.44-53.2,36.66-88.46,36.66h-102.14V5.11h102.14Zm0,199.17c20.18,0,36.53-6.5,49.06-19.52,12.52-13.01,18.79-30.33,18.79-51.98s-6.26-38.97-18.79-51.98c-12.53-13.01-28.88-19.52-49.06-19.52h-43.77v143h43.77Z"
						/>
						<path
							className="fill-dark"
							d="m2260.04,227.26c-25.78,25.53-57.15,38.3-94.11,38.3s-68.34-12.77-94.11-38.3c-25.78-25.54-38.67-57.03-38.67-94.48s12.89-68.94,38.67-94.48c25.77-25.53,57.15-38.3,94.11-38.3s68.33,12.77,94.11,38.3c25.77,25.53,38.67,57.03,38.67,94.48s-12.89,68.94-38.67,94.48Zm-147.19-39.76c14.23,14.11,31.92,21.16,53.08,21.16s38.85-7.05,53.08-21.16c14.23-14.1,21.34-32.34,21.34-54.72s-7.11-40.61-21.34-54.72c-14.23-14.1-31.92-21.16-53.08-21.16s-38.85,7.06-53.08,21.16c-14.23,14.11-21.34,32.35-21.34,54.72s7.11,40.62,21.34,54.72Z"
						/>
						<path
							className="fill-dark"
							d="m2473.8,5.11h58.36v255.35h-43.77l-98.49-138.62v138.62h-58.37V5.11h43.77l98.49,138.62V5.11Z"
						/>
						<path
							className="fill-dark"
							d="m2634.31,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
						/>
						<path
							className="fill-white"
							d="m1468.48,257.25L1399.35,6.52h60.17l43.34,175.51,48.35-175.51h46.57l48.35,175.51,43.34-175.51h60.17l-69.13,250.73h-65.19l-40.83-147.93-40.83,147.93h-65.19Z"
						/>
						<path
							className="fill-white"
							d="m1264.85,200.26h101.42v55.78h-159.38V2.49h157.57v55.78h-99.61v42.02h90.55v55.06h-90.55v44.92Z"
						/>
						<path
							className="fill-white"
							d="m1104.75,256.04l-47.81-83.31h-27.53v83.31h-57.96V2.49h101.42c24.14,0,44.67,8.46,61.58,25.36,16.9,16.91,25.36,37.43,25.36,61.58,0,15.46-4.29,29.76-12.86,42.92-8.57,13.16-19.87,23.36-33.87,30.61l53.97,93.09h-62.3Zm-75.34-199.22v65.2h43.47c7.97,0,14.79-3.14,20.47-9.42,5.67-6.28,8.51-14,8.51-23.18s-2.84-16.9-8.51-23.18c-5.68-6.28-12.5-9.42-20.47-9.42h-43.47Z"
						/>
						<path
							className="fill-white"
							d="m676.38,117.89c2.89-33.26,14.31-55.83,37.46-79.21,26.46-26.71,60.26-36.19,100.4-36.19,24.03,0,46.27,5.56,66.73,16.68,20.45,11.12,36.56,26.27,48.32,45.45l-52.93,30.68c-5.88-10.48-14.32-18.6-25.31-24.35-11-5.75-23.27-8.63-36.82-8.63-23.78,0-39.65,4.47-55.55,18.66-5.06,4.52-6.93,7.53-10.08,13.44l-72.23,23.47Z"
						/>
						<polygon
							className="fill-white"
							points="657.22 216.72 700.27 193.05 667.34 342.97 777.89 135.67 733.88 156.72 747.61 106.22 676.37 131.49 657.22 216.72"
						/>
						<path
							className="fill-white"
							d="m736.97,234.73l2.54,1.86c23.45,17.63,48.89,24.66,81.4,24.82,24.29.11,46.68-5.34,67.19-16.37,20.5-11.03,36.56-26.1,48.15-45.22l-52.78-30.93c-5.67,10.2-14.08,18.22-25.23,24.04-11.15,5.83-23.5,8.71-37.05,8.65-23.78-.11-40.34-5.12-54.47-19.76l-29.76,52.91Z"
						/>
					</g>
				</g>
			</svg>
		);
	}

	if (color === "white") {
		return (
			<svg
				id="Laag_2"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 2736.44 342.97"
				{...{ className }}
			>
				<g id="Laag_1-2">
					<g>
						<path
							className="fill-white"
							d="m263.74,118.19v21.89c0,38.18-11.86,68.64-35.57,91.38-23.71,22.74-53.81,34.11-90.28,34.11-39.64,0-72.53-12.77-98.67-38.3C13.07,201.72,0,170.35,0,133.15S12.95,64.45,38.85,38.67C64.75,12.89,96.42,0,133.88,0c23.83,0,45.66,5.35,65.48,16.05,19.82,10.7,35.2,24.81,46.15,42.31l-49.61,28.45c-5.6-8.75-13.92-15.92-24.99-21.52-11.07-5.59-23.53-8.39-37.39-8.39-21.65,0-39.58,7.18-53.81,21.52-14.23,14.35-21.34,32.71-21.34,55.08s7.3,40.19,21.89,54.17c14.59,13.99,34.04,20.98,58.36,20.98,33.8,0,55.57-13.13,65.3-39.4h-68.21v-51.07h128.04Z"
						/>
						<path
							className="fill-white"
							d="m354.93,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
						/>
						<path
							className="fill-white"
							d="m661.35,5.11v56.18h-65.66v199.17h-58.36V61.28h-65.66V5.11h189.69Z"
						/>
						<path
							className="fill-white"
							d="m1887.24,5.11c35.26,0,64.75,12.22,88.46,36.66,23.71,24.44,35.57,54.78,35.57,91.01s-11.85,66.57-35.57,91.01c-23.71,24.44-53.2,36.66-88.46,36.66h-102.14V5.11h102.14Zm0,199.17c20.18,0,36.53-6.5,49.06-19.52,12.52-13.01,18.79-30.33,18.79-51.98s-6.26-38.97-18.79-51.98c-12.53-13.01-28.88-19.52-49.06-19.52h-43.77v143h43.77Z"
						/>
						<path
							className="fill-white"
							d="m2260.04,227.26c-25.78,25.53-57.15,38.3-94.11,38.3s-68.34-12.77-94.11-38.3c-25.78-25.54-38.67-57.03-38.67-94.48s12.89-68.94,38.67-94.48c25.77-25.53,57.15-38.3,94.11-38.3s68.33,12.77,94.11,38.3c25.77,25.53,38.67,57.03,38.67,94.48s-12.89,68.94-38.67,94.48Zm-147.19-39.76c14.23,14.11,31.92,21.16,53.08,21.16s38.85-7.05,53.08-21.16c14.23-14.1,21.34-32.34,21.34-54.72s-7.11-40.61-21.34-54.72c-14.23-14.1-31.92-21.16-53.08-21.16s-38.85,7.06-53.08,21.16c-14.23,14.11-21.34,32.35-21.34,54.72s7.11,40.62,21.34,54.72Z"
						/>
						<path
							className="fill-white"
							d="m2473.8,5.11h58.36v255.35h-43.77l-98.49-138.62v138.62h-58.37V5.11h43.77l98.49,138.62V5.11Z"
						/>
						<path
							className="fill-white"
							d="m2634.31,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
						/>
						<path
							className="fill-primary"
							d="m1468.48,257.25L1399.35,6.52h60.17l43.34,175.51,48.35-175.51h46.57l48.35,175.51,43.34-175.51h60.17l-69.13,250.73h-65.19l-40.83-147.93-40.83,147.93h-65.19Z"
						/>
						<path
							className="fill-primary"
							d="m1264.85,200.26h101.42v55.78h-159.38V2.49h157.57v55.78h-99.61v42.02h90.55v55.06h-90.55v44.92Z"
						/>
						<path
							className="fill-primary"
							d="m1104.75,256.04l-47.81-83.31h-27.53v83.31h-57.96V2.49h101.42c24.14,0,44.67,8.46,61.58,25.36,16.9,16.91,25.36,37.43,25.36,61.58,0,15.46-4.29,29.76-12.86,42.92-8.57,13.16-19.87,23.36-33.87,30.61l53.97,93.09h-62.3Zm-75.34-199.22v65.2h43.47c7.97,0,14.79-3.14,20.47-9.42,5.67-6.28,8.51-14,8.51-23.18s-2.84-16.9-8.51-23.18c-5.68-6.28-12.5-9.42-20.47-9.42h-43.47Z"
						/>
						<path
							className="fill-primary"
							d="m676.38,117.89c2.89-33.26,14.31-55.83,37.46-79.21,26.46-26.71,60.26-36.19,100.4-36.19,24.03,0,46.27,5.56,66.73,16.68,20.45,11.12,36.56,26.27,48.32,45.45l-52.93,30.68c-5.88-10.48-14.32-18.6-25.31-24.35-11-5.75-23.27-8.63-36.82-8.63-23.78,0-39.65,4.47-55.55,18.66-5.06,4.52-6.93,7.53-10.08,13.44l-72.23,23.47Z"
						/>
						<polygon
							className="fill-primary"
							points="657.22 216.72 700.27 193.05 667.34 342.97 777.89 135.67 733.88 156.72 747.61 106.22 676.37 131.49 657.22 216.72"
						/>
						<path
							className="fill-primary"
							d="m736.97,234.73l2.54,1.86c23.45,17.63,48.89,24.66,81.4,24.82,24.29.11,46.68-5.34,67.19-16.37,20.5-11.03,36.56-26.1,48.15-45.22l-52.78-30.93c-5.67,10.2-14.08,18.22-25.23,24.04-11.15,5.83-23.5,8.71-37.05,8.65-23.78-.11-40.34-5.12-54.47-19.76l-29.76,52.91Z"
						/>
					</g>
				</g>
			</svg>
		);
	}

	return (
		<svg
			id="Laag_2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 2736.44 342.97"
			{...{ className }}
		>
			<g id="Laag_1-2">
				<g>
					<path
						className="fill-dark"
						d="m263.74,118.19v21.89c0,38.18-11.86,68.64-35.57,91.38-23.71,22.74-53.81,34.11-90.28,34.11-39.64,0-72.53-12.77-98.67-38.3C13.07,201.72,0,170.35,0,133.15S12.95,64.45,38.85,38.67C64.75,12.89,96.42,0,133.88,0c23.83,0,45.66,5.35,65.48,16.05,19.82,10.7,35.2,24.81,46.15,42.31l-49.61,28.45c-5.6-8.75-13.92-15.92-24.99-21.52-11.07-5.59-23.53-8.39-37.39-8.39-21.65,0-39.58,7.18-53.81,21.52-14.23,14.35-21.34,32.71-21.34,55.08s7.3,40.19,21.89,54.17c14.59,13.99,34.04,20.98,58.36,20.98,33.8,0,55.57-13.13,65.3-39.4h-68.21v-51.07h128.04Z"
					/>
					<path
						className="fill-dark"
						d="m354.93,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
					/>
					<path
						className="fill-dark"
						d="m661.35,5.11v56.18h-65.66v199.17h-58.36V61.28h-65.66V5.11h189.69Z"
					/>
					<path
						className="fill-dark"
						d="m1887.24,5.11c35.26,0,64.75,12.22,88.46,36.66,23.71,24.44,35.57,54.78,35.57,91.01s-11.85,66.57-35.57,91.01c-23.71,24.44-53.2,36.66-88.46,36.66h-102.14V5.11h102.14Zm0,199.17c20.18,0,36.53-6.5,49.06-19.52,12.52-13.01,18.79-30.33,18.79-51.98s-6.26-38.97-18.79-51.98c-12.53-13.01-28.88-19.52-49.06-19.52h-43.77v143h43.77Z"
					/>
					<path
						className="fill-dark"
						d="m2260.04,227.26c-25.78,25.53-57.15,38.3-94.11,38.3s-68.34-12.77-94.11-38.3c-25.78-25.54-38.67-57.03-38.67-94.48s12.89-68.94,38.67-94.48c25.77-25.53,57.15-38.3,94.11-38.3s68.33,12.77,94.11,38.3c25.77,25.53,38.67,57.03,38.67,94.48s-12.89,68.94-38.67,94.48Zm-147.19-39.76c14.23,14.11,31.92,21.16,53.08,21.16s38.85-7.05,53.08-21.16c14.23-14.1,21.34-32.34,21.34-54.72s-7.11-40.61-21.34-54.72c-14.23-14.1-31.92-21.16-53.08-21.16s-38.85,7.06-53.08,21.16c-14.23,14.11-21.34,32.35-21.34,54.72s7.11,40.62,21.34,54.72Z"
					/>
					<path
						className="fill-dark"
						d="m2473.8,5.11h58.36v255.35h-43.77l-98.49-138.62v138.62h-58.37V5.11h43.77l98.49,138.62V5.11Z"
					/>
					<path
						className="fill-dark"
						d="m2634.31,204.28h102.14v56.18h-160.5V5.11h158.68v56.18h-100.31v42.31h91.2v55.45h-91.2v45.23Z"
					/>
					<path
						className="fill-primary"
						d="m1468.48,257.25L1399.35,6.52h60.17l43.34,175.51,48.35-175.51h46.57l48.35,175.51,43.34-175.51h60.17l-69.13,250.73h-65.19l-40.83-147.93-40.83,147.93h-65.19Z"
					/>
					<path
						className="fill-primary"
						d="m1264.85,200.26h101.42v55.78h-159.38V2.49h157.57v55.78h-99.61v42.02h90.55v55.06h-90.55v44.92Z"
					/>
					<path
						className="fill-primary"
						d="m1104.75,256.04l-47.81-83.31h-27.53v83.31h-57.96V2.49h101.42c24.14,0,44.67,8.46,61.58,25.36,16.9,16.91,25.36,37.43,25.36,61.58,0,15.46-4.29,29.76-12.86,42.92-8.57,13.16-19.87,23.36-33.87,30.61l53.97,93.09h-62.3Zm-75.34-199.22v65.2h43.47c7.97,0,14.79-3.14,20.47-9.42,5.67-6.28,8.51-14,8.51-23.18s-2.84-16.9-8.51-23.18c-5.68-6.28-12.5-9.42-20.47-9.42h-43.47Z"
					/>
					<path
						className="fill-primary"
						d="m676.38,117.89c2.89-33.26,14.31-55.83,37.46-79.21,26.46-26.71,60.26-36.19,100.4-36.19,24.03,0,46.27,5.56,66.73,16.68,20.45,11.12,36.56,26.27,48.32,45.45l-52.93,30.68c-5.88-10.48-14.32-18.6-25.31-24.35-11-5.75-23.27-8.63-36.82-8.63-23.78,0-39.65,4.47-55.55,18.66-5.06,4.52-6.93,7.53-10.08,13.44l-72.23,23.47Z"
					/>
					<polygon
						className="fill-primary"
						points="657.22 216.72 700.27 193.05 667.34 342.97 777.89 135.67 733.88 156.72 747.61 106.22 676.37 131.49 657.22 216.72"
					/>
					<path
						className="fill-primary"
						d="m736.97,234.73l2.54,1.86c23.45,17.63,48.89,24.66,81.4,24.82,24.29.11,46.68-5.34,67.19-16.37,20.5-11.03,36.56-26.1,48.15-45.22l-52.78-30.93c-5.67,10.2-14.08,18.22-25.23,24.04-11.15,5.83-23.5,8.71-37.05,8.65-23.78-.11-40.34-5.12-54.47-19.76l-29.76,52.91Z"
					/>
				</g>
			</g>
		</svg>
	);
};

const GetJobsDone = ({ variant, color, className }: LogoProps) => {
	const fill = `fill-${color}`;

	if (variant === "small") {
		return (
			<svg
				{...{ className }}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 28.87 30"
			>
				<g id="Laag_2" data-name="Laag 2">
					<g id="Laag_1-2" data-name="Laag 1">
						<path
							className={fill}
							d="M28.63,14.47a3.05,3.05,0,0,0-2.46-1.93c-.14,0-7.6-.11-7.6-.11-1.86-.06-2.51.07-3.28.66a3.63,3.63,0,0,0-1.48,2.74,2.4,2.4,0,0,0,1,2,4,4,0,0,0,2.35.4l3.17,0c-1.65,4-4.06,5.89-7.49,5.87-3.69,0-5.73-2.23-5.7-6.21A13.7,13.7,0,0,1,9.7,10c2-2.64,4.57-4.13,7.1-4.11A7.43,7.43,0,0,1,20.69,7c2.39,1.77,2.65,1.9,3.59,1.91a3.75,3.75,0,0,0,3.58-3.45C27.87,2.59,23.39,0,18.33,0A17.69,17.69,0,0,0,5.06,5.75a20.1,20.1,0,0,0-5,13,11.28,11.28,0,0,0,1.88,6.62C4,28.46,7.09,30,11.42,30A16.77,16.77,0,0,0,16,29.4l.16,0h0a15.11,15.11,0,0,0,4.08-1.88A7.7,7.7,0,0,0,23,23.24h0l-.06.44a3.48,3.48,0,0,0,.06,2,2.38,2.38,0,0,0,4.11.55,3.4,3.4,0,0,0,.59-1.93l1-7.2A4.52,4.52,0,0,0,28.63,14.47Z"
						/>
					</g>
				</g>
			</svg>
		);
	}
	return (
		<svg
			{...{ className }}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 522.01 67.24"
		>
			<g id="Laag_2" data-name="Laag 2">
				<g id="Laag_1-2" data-name="Laag 1">
					<g id="Group_2" data-name="Group 2">
						<path
							id="Path_229"
							data-name="Path 229"
							className={fill}
							d="M92.76,19.43A28,28,0,0,0,73,27.93c-5.1,5.37-8.6,13.88-8.6,21a18.4,18.4,0,0,0,5,12.26c3.49,3.59,8.33,5.37,14.68,5.37,6.18,0,12.9-1.78,17.37-4.74,3-2,4.57-4,4.57-6.36,0-2.68-1.79-4.65-4.21-4.65a8.82,8.82,0,0,0-3,.62c-7.61,3.4-8.42,3.67-11.73,3.67-5.2,0-8-2.5-8.69-7.78h24.54c5.28,0,7.25-2.78,7.25-9.94C110.13,27,102.88,19.43,92.76,19.43Zm-13,19c3.13-5.55,6.72-8.24,10.92-8.24a6.71,6.71,0,0,1,5.37,2.33c1,1.25,1.35,2.77,1.44,5.91Z"
						/>
						<path
							id="Path_230"
							data-name="Path 230"
							className={fill}
							d="M148.24,25.16c0-3.49-2-4.84-6.8-4.84H139l1.43-6.8A11.46,11.46,0,0,0,141,10a5,5,0,0,0-4.76-5.19h-.43a8.43,8.43,0,0,0-6.45,3.22c-1,1.43-1.34,2.24-2,5.46l-1.52,6.8c-3.13,0-3.85.09-5.37.81a7.25,7.25,0,0,0-4.12,6.27c0,3.49,2.06,4.92,7,4.83L118,57.57a11.46,11.46,0,0,0-.54,3.49,5,5,0,0,0,4.72,5.28h.48a8.27,8.27,0,0,0,6.44-3.22c1.08-1.43,1.34-2.33,2.06-5.55l5.37-25.34h2.42c3.49,0,4.83-.27,6.36-1.43A7.4,7.4,0,0,0,148.24,25.16Z"
						/>
						<path
							id="Path_231"
							data-name="Path 231"
							className={fill}
							d="M183.23,10.56a5.19,5.19,0,0,0-4.92-5.45h-.45a8.63,8.63,0,0,0-6.8,3.4c-1,1.53-1.34,2.33-2.06,5.73l-6.89,32.5c-1.08,5-3.23,7.7-6.27,7.7A7,7,0,0,1,152,52.91c-1.88-1.25-2.6-1.52-4-1.52A8,8,0,0,0,140.08,59c0,4.74,5.91,8.24,14,8.24,5.82,0,11.55-2,14.86-5.2s5.28-7.79,6.89-15.31l6.9-32.5A13.74,13.74,0,0,0,183.23,10.56Z"
						/>
						<path
							id="Path_232"
							data-name="Path 232"
							className={fill}
							d="M212.67,19.43A28.12,28.12,0,0,0,192,29a32.26,32.26,0,0,0-7.16,19.78c0,10.21,7.43,17.82,17.37,17.82A27.73,27.73,0,0,0,222.79,57,32.57,32.57,0,0,0,230,37.42C230,27.13,222.61,19.43,212.67,19.43Zm-8,34.92c-3.85,0-6.63-3.23-6.63-7.61,0-7.79,5.55-15,11.64-15,4.3,0,7.08,3.22,7.08,8.23C216.79,47.27,210.88,54.35,204.71,54.35Z"
						/>
						<path
							id="Path_233"
							data-name="Path 233"
							className={fill}
							d="M264,19.43c-3.94,0-6.89,1-11.37,3.85l3-14.5a14.5,14.5,0,0,0,.54-3.58A5,5,0,0,0,251.41,0H251a8.3,8.3,0,0,0-6.45,3.23c-1,1.43-1.34,2.32-2,5.55L231.82,59.36a7.55,7.55,0,0,0-.27,1.88c0,3,2.33,5.1,5.55,5.1,3.05,0,5.19-1.52,7.16-4.92,2.06,3.67,4.93,5.19,9.76,5.19a24.37,24.37,0,0,0,18.18-8.68,33.89,33.89,0,0,0,7.88-20.68C280.08,27.13,273.09,19.43,264,19.43Zm-9,34.91c-4.12,0-7-3.22-7-7.79,0-7.7,5.73-14.86,12-14.86,4,0,6.72,3.14,6.72,8.06,0,7.43-5.73,14.6-11.73,14.6Z"
						/>
						<path
							id="Path_234"
							data-name="Path 234"
							className={fill}
							d="M308,19.43c-11.37,0-20.24,7.7-20.24,17.46,0,3.49,1.61,5.91,5.11,7.88a46,46,0,0,0,7.07,3.31c3.4,1.34,4.3,2.06,4.3,3.4,0,1.79-2.24,3.49-4.57,3.49a10.91,10.91,0,0,1-4.92-1.43c-4.66-2.33-4.66-2.33-6.27-2.33-3.31,0-6.8,3.58-6.8,6.8,0,4.74,6.8,8.59,15,8.59,6.18,0,12-2.14,15.49-5.73,3-3.22,5.1-7.78,5.1-11.46a8.85,8.85,0,0,0-2-5.64c-1.88-2.41-3.22-3.31-8.68-5.73s-5.82-2.68-5.82-4.2,1.7-2.78,4-2.78a10.29,10.29,0,0,1,4.65,1.34c3.67,1.7,3.76,1.79,5.19,1.79,3.05,0,6.36-3.49,6.36-6.62C321.07,23.1,315.25,19.43,308,19.43Z"
						/>
						<path
							id="Path_235"
							data-name="Path 235"
							className={fill}
							d="M355,6h-12.9A9.6,9.6,0,0,0,334.57,9c-1.43,1.52-2,2.87-2.86,7L323.29,55.6a18.4,18.4,0,0,0-.62,4.12,5.35,5.35,0,0,0,1.88,4.3c1.34,1.25,2.32,1.43,6.44,1.52l13.34.18a32.9,32.9,0,0,0,24.26-9.67,40.8,40.8,0,0,0,10.93-27.49C379.52,14.06,370.74,6,355,6Zm4.74,40a18,18,0,0,1-15.49,7.79h-6.8l7.61-35.9h5.19c10.12,0,14.6,3.85,14.6,12.35A27.75,27.75,0,0,1,359.73,46Z"
						/>
						<path
							id="Path_236"
							data-name="Path 236"
							className={fill}
							d="M409,19.43A28.1,28.1,0,0,0,388.28,29a32.26,32.26,0,0,0-7.16,19.78c0,10.21,7.43,17.82,17.36,17.82A27.75,27.75,0,0,0,419.08,57a32.57,32.57,0,0,0,7.16-19.61C426.24,27.13,418.9,19.43,409,19.43Zm-8,34.91c-3.85,0-6.62-3.22-6.62-7.61,0-7.78,5.55-15,11.64-15,4.3,0,7.07,3.23,7.07,8.24,0,7.34-5.91,14.42-12.09,14.42Z"
						/>
						<path
							id="Path_237"
							data-name="Path 237"
							className={fill}
							d="M461.32,19.43c-5.1,0-8.5,1.25-13.16,4.83-.63-3.13-2.24-4.56-5.1-4.56-4.21,0-7.34,2.86-8.33,7.7l-6.44,30.17a15.74,15.74,0,0,0-.45,3.49,5,5,0,0,0,4.72,5.28H433a8.39,8.39,0,0,0,6.45-3.22c1-1.43,1.25-2.33,2-5.55l4-19c.9-4.21,5.1-7.79,9.13-7.79,3.49,0,5.91,2.24,5.91,5.46a11.5,11.5,0,0,1-.36,2.86l-3.94,18.45a17,17,0,0,0-.45,3.49,5,5,0,0,0,4.72,5.28H461a8.37,8.37,0,0,0,6.44-3.22c1-1.43,1.25-2.33,2-5.55L474,36a27.73,27.73,0,0,0,.71-5.37C474.66,24.08,469.11,19.43,461.32,19.43Z"
						/>
						<path
							id="Path_238"
							data-name="Path 238"
							className={fill}
							d="M522,37.42c0-10.47-7.25-18-17.37-18a28,28,0,0,0-19.79,8.5c-5.1,5.37-8.59,13.88-8.59,21a18.47,18.47,0,0,0,5,12.26c3.5,3.59,8.33,5.37,14.69,5.37,6.17,0,12.89-1.78,17.36-4.74,3-2,4.57-4,4.57-6.36,0-2.68-1.79-4.65-4.21-4.65a8.82,8.82,0,0,0-3,.62c-7.61,3.4-8.42,3.67-11.73,3.67-5.19,0-8-2.5-8.68-7.78h24.53C520,47.36,522,44.59,522,37.42Zm-30.35,1c3.13-5.55,6.71-8.24,10.92-8.24A6.73,6.73,0,0,1,508,32.5c1,1.25,1.35,2.77,1.44,5.91Z"
						/>
						<path
							id="Path_239"
							data-name="Path 239"
							className={fill}
							d="M59.78,34.47a6.46,6.46,0,0,0-5.17-4c-.29,0-15.88-.12-15.88-.12-3.89-.1-5.24.17-6.85,1.42a7.57,7.57,0,0,0-3,5.73,5,5,0,0,0,2.06,4.21c1.25.72,2,.8,4.92.8h6.63C39.05,50.84,34,54.87,26.87,54.87c-7.7,0-12-4.57-12-12.9a28.62,28.62,0,0,1,5.28-16.65c4.12-5.55,9.49-8.69,14.77-8.69a15.7,15.7,0,0,1,8.15,2.24c5,3.67,5.55,3.94,7.52,3.94,3.76,0,7.43-3.58,7.43-7.25,0-5.91-9.4-11.19-20-11.19A37,37,0,0,0,10.39,16.55,42.12,42.12,0,0,0,0,43.68,23.35,23.35,0,0,0,4,57.47C8.43,64,15,67.13,24,67.13a34.46,34.46,0,0,0,9.53-1.31l.34-.1h0a32,32,0,0,0,8.52-4,16.16,16.16,0,0,0,5.8-8.87h0l-.12.9c-.31,2.44-.31,3,.15,4.22a5,5,0,0,0,8.6,1.11c.76-1.08.9-1.68,1.21-4.05L60,40C60.38,36.81,60.38,36.09,59.78,34.47Z"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

Logo.GetCrewDone = GetCrewDone;
Logo.GetJobsDone = GetJobsDone;

Logo.defaultProps = {
	variant: "default",
};

export default Logo;
